module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/finance/refundlist/refundlist.component.css
// module id = ./src/app/finance/refundlist/refundlist.component.css
// module chunks = main